import { render, staticRenderFns } from "./aiShareCard1.vue?vue&type=template&id=158893c9&scoped=true"
import script from "./aiShareCard1.vue?vue&type=script&lang=js"
export * from "./aiShareCard1.vue?vue&type=script&lang=js"
import style0 from "./aiShareCard1.vue?vue&type=style&index=0&id=158893c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158893c9",
  null
  
)

export default component.exports